import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './MyStakesIcon.module.scss';

const MyStakesIcon: FC= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="94"
         height="93"
         fill="none"
         viewBox="0 0 94 93">
      <circle cx="47"
              cy="46.5"
              r="46.5"
              className={styles.background} />
      <g mask="url(#mask0_2849_5516)">
        <path className={classNames(styles.item, styles.border)}
              strokeWidth=".5"
              d="m14.8 45.5 1.8-24h65.6l-2 24H14.9Z" />
        <path className={styles.skeleton}
              d="M21.2 25.2h35.4L56 28H20.7l.5-2.8Z" />
        <path className={styles.skeleton}
              d="M20.7 30.9h12.5l-.5 2.9H20.2l.5-2.9Z" />
        <g clipPath="url(#clip0_2849_5516)">
          <path className={styles.checkMark}
                d="m70.8 30.8-.4-.1-1.7-1.7a.6.6 0 0 1 .8-.8l1.2 1.2 3.5-4.5a.6.6 0 1 1 1 .7l-4 5a.6.6 0 0 1-.4.2Z" />
        </g>
        <path className={classNames(styles.item, styles.border)}
              strokeWidth=".5"
              d="m12.6 71 2-24H80l-1.8 24H12.6Z" />
        <path className={styles.skeleton}
              d="M19 50.6h35.5l-.5 2.9H18.6l.5-2.9Z" />
        <path className={styles.skeleton}
              d="M18.6 56.4H31l-.5 2.8H18.1l.5-2.8Z" />
        <g clipPath="url(#clip1_2849_5516)">
          <path className={styles.checkMark}
                d="M68.6 56.3c-.1 0-.2 0-.3-.2l-1.7-1.7a.6.6 0 0 1 .8-.8l1.2 1.3 3.5-4.6a.6.6 0 0 1 .9.7l-4 5a.6.6 0 0 1-.3.3Z" />
        </g>
      </g>
    </svg>
  );
};

export default MyStakesIcon;
